query ContentPolls($contentId: ID!) {
  contentPolls(contentId: $contentId) {
    id
    contentId
    pollId
    question
    options {
      id
      text
      isCorrect
      votes
    }
    isMultiple
    resultsMode
    trigger
    offsetSeconds
    startsAt
    autoCloseSeconds
    status
    openedAt
    closedAt
    votersCount
    correctVotersCount
    createdAt
  }
}
